import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.Dashboard.title',
    defaultMessage: 'Claims dashboard',
  },
  connectUs: {
    id: 'src.pages.Dashboard.connectUs',
    defaultMessage: 'Managing your claims is simpler than you think',
  },
  reportAClaim: {
    id: 'src.pages.Dashboard.reportAClaim',
    defaultMessage: 'Make a digital claim',
  },
  reportAClaimSubtitle: {
    id: 'src.pages.Dashboard.reportAClaimSubtitle',
    defaultMessage: 'Submit a claim request all online.',
  },
  getATow: {
    id: 'src.pages.Dashboard.getATow',
    defaultMessage: 'Get a tow',
  },
  getATowSubtitle: {
    id: 'src.pages.Dashboard.getATowSubtitle',
    defaultMessage: 'Stuck on the roadside? We can help.',
  },
  emergencyHomeRepais: {
    id: 'src.pages.Dashboard.emergencyHomeRepais',
    defaultMessage: 'Arrange emergency home repairs',
  },
  emergencyHomeRepaisSubtitle: {
    id: 'src.pages.Dashboard.emergencyHomeRepaisSubtitle',
    defaultMessage: 'Need help fast? We’ve got your back',
  },
  callUs: {
    id: 'src.pages.Dashboard.callUs',
    defaultMessage: 'Talk to a Claims team member directly at ',
  },
  claimsDraft: {
    id: 'src.pages.Dashboard.claimsDraft',
    defaultMessage: 'Your claims',
  },
  noClaims: {
    id: 'src.pages.Dashboard.noClaims',
    defaultMessage: 'Looks like you don’t have any current or past claims with Sonnet. If you do submit a claim, it will appear here along with the claim status and other important information.',
  },
  incompeteDraft: {
    id: 'src.pages.Dashboard.incompeteDraft',
    defaultMessage: 'You have {claimsCount} incompete claim(s)',
  },
  // FAQs
  faqs: {
    id: 'src.pages.Dashboard.faqs',
    defaultMessage: 'FAQs',
  },
  // CLAIM CARD TITLES
  vehicle: {
    id: 'src.pages.Dashboard.vehicle',
    defaultMessage: 'Vehicle',
  },
  property: {
    id: 'src.pages.Dashboard.property',
    defaultMessage: 'Property',
  },
  claimType: {
    id: 'src.pages.Dashboard.claimType',
    defaultMessage: 'Claim type',
  },
  incidentDate: {
    id: 'src.pages.Dashboard.incidentDate',
    defaultMessage: 'Incident date',
  },

  // CLAIM CARD VALUES
  claimNumberText: {
    id: 'src.pages.Dashboard.claimNumber',
    defaultMessage: 'Claim #{claimId}',
  },
  claimNumberNoText: {
    id: 'src.pages.Dashboard.claimNumberId',
    defaultMessage: '{claimId}',
  },
  claimNumberGW: {
    id: 'src.pages.Dashboard.claimNumberRef',
    defaultMessage: 'Reference #{claimId}',
  },
  vehicleModel: {
    id: 'src.pages.Dashboard.vehicleModel',
    defaultMessage: '{vehicleModel}',
  },
  propertyAddress: {
    id: 'src.pages.Dashboard.propertyAddress',
    defaultMessage: '{propertyAddress}',
  },
  claimTypeDescription: {
    id: 'src.pages.Dashboard.claimTypeDescription',
    defaultMessage: '{claimTypeDescription}',
  },
  dateOfIncident: {
    id: 'src.pages.Dashboard.dateOfIncident',
    defaultMessage: '{formattedDate}',
  },
  claimStatus: {
    id: 'src.pages.Dashboard.claimStatus',
    defaultMessage: '  {claimStatus}',
  },
  adjusterDetails: {
    id: 'src.pages.Dashboard.adjusterDetails',
    defaultMessage: 'Adjuster Details',
  },

  // CLAIM ACTIONS
  removeClaim: {
    id: 'src.pages.Dashboard.removeClaim',
    defaultMessage: 'Remove',
  },
  continueClaim: {
    id: 'src.pages.Dashboard.continueClaim',
    defaultMessage: 'Resume claim  ',
  },
  continueClaimPhone: {
    id: 'src.pages.Dashboard.continueClaimPhone',
    defaultMessage: 'Resume ',
  },
  seeDetails: {
    id: 'src.pages.Dashboard.seeDetails',
    defaultMessage: 'See Details',
  },

  // DATES
  expiresDate: {
    id: 'src.pages.Dashboard.expiresDate',
    defaultMessage: '{untilDaysUntilExpires, plural, one {Expires in # day} other {Expires in # days}}',
  },
  expiresToday: {
    id: 'src.pages.Dashboard.expiresToday',
    defaultMessage: 'Expires Today',
  },
  expired: {
    id: 'src.pages.Dashboard.expired',
    defaultMessage: 'Expired',
  },

  // URLs
  getATowUrl: {
    id: 'src.pages.Dashboard.getATowUrl',
    defaultMessage: 'https://www.sonnet.ca/faqs/claims/auto/towing-location',
  },
  emergencyHomeRepairsUrl: {
    id: 'src.pages.Dashboard.emergencyHomeRepairsUrl',
    defaultMessage: 'https://www.sonnet.ca/faqs/claims/property/emergency-services',
  },
});
